import { render, staticRenderFns } from "./ListMedcontrat.vue?vue&type=template&id=3b1550c2&"
import script from "./ListMedcontrat.vue?vue&type=script&lang=js&"
export * from "./ListMedcontrat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports